export const snackbar_options = {duration: 4000};
